<script setup>
import { computed, markRaw } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import ChartBar from '@primeicons/vue/chart-bar';
import Comments from '@primeicons/vue/comments';
import Inbox from '@primeicons/vue/inbox';
import Star from '@primeicons/vue/star';
import Tags from '@primeicons/vue/tags';
import Users from '@primeicons/vue/users';

const route = useRoute();
const { t } = useI18n();

const reportTabs = computed(() => [
  {
    label: t('REPORT_DASHBOARD.NAVIGATION.OVERVIEW'),
    icon: markRaw(ChartBar),
    routeName: 'account_overview_reports',
    activeRoutes: ['account_overview_reports'],
  },
  {
    label: t('REPORT_DASHBOARD.NAVIGATION.CONVERSATIONS'),
    icon: markRaw(Comments),
    routeName: 'conversation_reports',
    activeRoutes: ['conversation_reports'],
  },
  {
    label: t('REPORT_DASHBOARD.NAVIGATION.CSAT'),
    icon: markRaw(Star),
    routeName: 'csat_reports',
    activeRoutes: ['csat_reports'],
  },
  {
    label: t('REPORT_DASHBOARD.NAVIGATION.AGENTS'),
    icon: markRaw(Users),
    routeName: 'agent_reports_index',
    activeRoutes: [
      'agent_reports_index',
      'agent_reports_show',
      'agent_reports',
    ],
  },
  {
    label: t('REPORT_DASHBOARD.NAVIGATION.CHANNELS'),
    icon: markRaw(Inbox),
    routeName: 'inbox_reports_index',
    activeRoutes: [
      'inbox_reports_index',
      'inbox_reports_show',
      'inbox_reports',
    ],
  },
  {
    label: t('REPORT_DASHBOARD.NAVIGATION.TEAMS'),
    icon: markRaw(Users),
    routeName: 'team_reports_index',
    activeRoutes: ['team_reports_index', 'team_reports_show', 'team_reports'],
  },
  {
    label: t('REPORT_DASHBOARD.NAVIGATION.LABELS'),
    icon: markRaw(Tags),
    routeName: 'label_reports_index',
    activeRoutes: [
      'label_reports_index',
      'label_reports_show',
      'label_reports',
    ],
  },
]);

const isActive = item => item.activeRoutes.includes(route.name);

const reportRoute = routeName => ({
  name: routeName,
  params: { accountId: route.params.accountId },
});
</script>

<template>
  <nav
    class="sticky top-0 z-10 -mx-6 border-b border-n-weak bg-n-background/95 px-6 backdrop-blur"
    :aria-label="t('REPORT_DASHBOARD.NAVIGATION.LABEL')"
  >
    <div class="mx-auto flex max-w-[90rem] gap-1 overflow-x-auto py-3">
      <router-link
        v-for="item in reportTabs"
        :key="item.routeName"
        :to="reportRoute(item.routeName)"
        class="flex h-9 flex-shrink-0 items-center gap-2 rounded-md px-3 text-sm font-medium text-n-slate-11 transition-colors hover:bg-n-alpha-2 hover:text-n-slate-12"
        :class="{
          'bg-n-teal-3 text-n-teal-11': isActive(item),
        }"
        :aria-current="isActive(item) ? 'page' : undefined"
      >
        <component :is="item.icon" :size="16" />
        <span>{{ item.label }}</span>
      </router-link>
    </div>
  </nav>
</template>
